// resources/js/charts.js
import * as echarts from 'echarts';

export function initChart(containerId, options) {
  var chartDom = document.getElementById(containerId);
  var myChart = echarts.init(chartDom);

  // Function to update chart's x-axis label rotation based on screen size
  function updateChartLabelRotation() {
    let rotateAngle = 0; // Default rotation angle

    if (window.matchMedia('(max-width: 640px)').matches) {
      rotateAngle = 45;
    } else if (window.matchMedia('(max-width: 768px)').matches) {
      rotateAngle = 30;
    } else if (window.matchMedia('(max-width: 1024px)').matches) {
      rotateAngle = 15;
    }

    // Update the rotation angle in the options
    if (options.xAxis && options.xAxis.axisLabel) {
      options.xAxis.axisLabel.rotate = rotateAngle;
    } else if (options.xAxis && Array.isArray(options.xAxis) && options.xAxis.length > 0 && options.xAxis[0].axisLabel) {
      // If xAxis is an array (multiple xAxes)
      options.xAxis[0].axisLabel.rotate = rotateAngle;
    }

    // Update the chart with the modified options
    myChart.setOption(options, true);
  }

  // Update label rotation based on the current screen size
  updateChartLabelRotation();

  // Listen to resize events to update the chart and label rotation
  window.addEventListener('resize', function () {
    myChart.resize();
    updateChartLabelRotation(); // Update rotation on resize as well
  });
}
